import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { LoginService } from '../../auth/login.service';

/** !isOnboarded → /onboarding; onboarded user must leave /onboarding. */
export const OnboardingGuard: CanActivateFn = (_route, state) => {
  const loginService = inject(LoginService);
  const router = inject(Router);
  const user = loginService.getUser();
  const onOnboarding = state.url.startsWith('/onboarding');
  const onboarded = user?.isOnboarded === true;

  if (!onboarded && !onOnboarding) {
    router.navigate(['/onboarding']);
    return false;
  }
  if (onboarded && onOnboarding) {
    router.navigate(['/profile']);
    return false;
  }
  return true;
};
